import { createActions, createReducer } from 'reduxsauce'

const situacoes = [
    { value: null, label: 'Todas' },
    { value: 'E', label: 'Estornado' },
    { value: 'R', label: 'Recebido' },
]
const origens = [
    { value: null, label: 'Todas' },
    { value: 'B', label: 'Arrecadação' },
    { value: 'F', label: 'Financeira' },
    { value: 'R', label: 'Retenção' },
]

/**
 * Action types & creators
 */

/**
 * Action types & creators
 */

export const { Types, Creators } = createActions({
    setExercicioConsultaReceitasExtraorcamentarias: ['exercicio'],
    setDataRecebimentoInicialConsultaReceitasExtraorcamentarias: ['dataRecebimentoInicial'],
    setDataRecebimentoFinalConsultaReceitasExtraorcamentarias: ['dataRecebimentoFinal'],
    setAdministracaoConsultaReceitasExtraorcamentarias: ['administracao'],
    setSituacaoConsultaReceitasExtraorcamentarias: ['situacao'],
    setOrigemConsultaReceitasExtraorcamentarias: ['origem'],
    setRecursoConsultaReceitasExtraorcamentarias: ['recurso'],
    setDestinacaoConsultaReceitasExtraorcamentarias: ['destinacao'],
    setNomeCredorConsultaReceitasExtraorcamentarias: ['nomeCredor'],
    setCnpjConsultaReceitasExtraorcamentarias: ['cnpj'],
    setCpfConsultaReceitasExtraorcamentarias: ['cpf'],
    limpaFiltroConsultaReceitasExtraorcamentarias: [],
    receberFiltroConsultaReceitasExtraorcamentarias: ['filtroRecebido'],
})

const INITIAL_STATE = {
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    dataRecebimentoInicial: '',
    dataRecebimentoFinal: '',
    administracao: null,
    destinacao: null,
    situacao: { value: situacoes[0].value, label: situacoes[0].label },
    origem: { value: origens[0].value, label: origens[0].label },
    nomeCredor: '',
    cnpj: '',
    cpf: '',
    recurso: null,
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}
const setDataRecebimentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataRecebimentoInicial: action.dataRecebimentoInicial }
}
const setDataRecebimentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataRecebimentoFinal: action.dataRecebimentoFinal }
}
const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}
const setSituacao = (state = INITIAL_STATE, action) => {
    return { ...state, situacao: action.situacao }
}
const setOrigem = (state = INITIAL_STATE, action) => {
    return { ...state, origem: action.origem }
}
const setRecurso = (state = INITIAL_STATE, action) => {
    return { ...state, recurso: action.recurso }
}
const setDestinacao = (state = INITIAL_STATE, action) => {
    return { ...state, destinacao: action.destinacao }
}
const setNomeCredor = (state = INITIAL_STATE, action) => {
    return { ...state, nomeCredor: action.nomeCredor }
}
const setCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: action.cnpj }
}
const setCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: action.cpf }
}
const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}
const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: setExercicio,
    [Types.SET_DATA_RECEBIMENTO_INICIAL_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: setDataRecebimentoInicial,
    [Types.SET_DATA_RECEBIMENTO_FINAL_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: setDataRecebimentoFinal,
    [Types.SET_ADMINISTRACAO_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: setAdministracao,
    [Types.SET_SITUACAO_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: setSituacao,
    [Types.SET_ORIGEM_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: setOrigem,
    [Types.SET_RECURSO_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: setRecurso,
    [Types.SET_DESTINACAO_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: setDestinacao,
    [Types.SET_NOME_CREDOR_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: setNomeCredor,
    [Types.SET_CNPJ_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: setCnpj,
    [Types.SET_CPF_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: setCpf,
    [Types.LIMPA_FILTRO_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: receberFiltro,
})
